'use client';

import { useEffect } from 'react';

export function ArticleViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    // Fire once per page load — no dedup needed for simple counting
    fetch('/api/article-views', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug }),
    }).catch(() => {});
  }, [slug]);

  return null; // Invisible component — just tracks
}
